exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".container{display:flex;flex-direction:column}.messages{overflow-y:scroll;overflow-x:hidden;flex-grow:1;padding:20px}h3{text-align:center;padding:20px 0;margin:0;border-bottom:1px solid #ddd;background-color:#eee}.chat-input{position:relative;overflow:hidden;padding:0 40px;flex-shrink:0}.chat-input input[type=text]{width:100%;margin-left:-20px;margin-right:-20px}.message.from-me{justify-content:flex-end;margin-bottom:1px;text-align:right}.message.from-me .message-body{background-color:#eee;color:#000}.message{margin-bottom:10px}.message-body{max-width:80%;display:inline-block;padding:5px;background-color:#2481b9;color:#fff;border:1px;border-radius:5px;padding-right:50px}.username{font-weight:700;font-size:.9rem;color:#999;margin-bottom:0}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./src/app/components/Screens/ContentGrid/chatclasses.css
// module id = 371
// module chunks = 0